// extracted by mini-css-extract-plugin
export default {"root":"TransactionsIcon_root__80gLF","blue":"TransactionsIcon_blue__OOxgp"};